module.exports = __webpack_public_path__ + "static/img/up-corner-ramp-8m-x-4m_256.3732163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-corner-ramp-8m-x-4m_256.png
// module id = r5bx
// module chunks = 0